import { render, staticRenderFns } from "./VDateTimePicker.vue?vue&type=template&id=2812cd99"
import script from "./VDateTimePicker.vue?vue&type=script&lang=ts"
export * from "./VDateTimePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports